import React, { useEffect, useRef, useState } from 'react';
import './login.css';
import { addDevice, getOttSettings, getSubscriber, saveSubscriberLoginHistory, sendOTP } from '../../Api/api';
import { Link, useNavigate } from 'react-router-dom';
import OTPScreen from './otpScreen';
import { utility } from '../../utility/utility';
import { ANALYTICS_EVENTS, DISPLAYPLATFORM, LOCAL_STORAGE_KEY, PLATFORM } from '../../constant';
import { toast } from 'react-toastify';
import DeleteDeviceConfirmationBox from '../homePage/components/DeleteDeviceConfirmationBox';
import { MESSAGE_TYPE } from '../../constant';
import { handleForegroundMessages, subscribeUserToTopics } from '../../firebase/firebaseHelper';
import { useDispatch } from 'react-redux';
import { setProfiles, setUser } from '../../redux/applicationSlice';
import AnalyticsManager from '../../analytics/analyticsManager';

const LoginWeb = () => {

    const [mobileNumber, setMobileNumber] = useState('');
    const [showVerifyOTP, setShowVerifyOTP] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '']);
    const [ottSetting, setOttSetting] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteDevicePopup, setShowDeleteDevicePopup] = useState(false);
    const [users, setUsers] = useState(null);
    const [sentOTPResMessage, setSentOTPResMessage] = useState('');

    const otpRef = useRef();
    const userRef = useRef();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = utility.getValue(LOCAL_STORAGE_KEY.user);

    useEffect(() => {
        loadOttSettings();
        subscribeUserToTopics(user)
        handleForegroundMessages();
    }, []);

    const loadOttSettings = async () => {
        const ottSettingRes = await getOttSettings();
        if (ottSettingRes.success) {
            console.log(ottSettingRes);
            setOttSetting({ ...ottSettingRes.data, piPageSetting: ottSettingRes?.piPageSetting });
        }
    }

    const handleInputChange = (e) => {
        const { value } = e.target;
        setMobileNumber(value);

        if (showVerifyOTP && mobileNumber.length == 4) {
            return
        }
        if (showVerifyOTP) {
            setMobileNumber(value);
        } else {
            setMobileNumber(value);
        }

    }

    const onLogin = async () => {
        if (isLoading) return;
        if (!showVerifyOTP) {
            let isValidEmail = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/.test(mobileNumber);
            let isValidMobile = /^\d{10}$/.test(mobileNumber);

            if ((ottSetting?.authenticationType == MESSAGE_TYPE.EMAIL && !isValidEmail) || (ottSetting?.authenticationType != MESSAGE_TYPE.EMAIL && !isValidMobile)) {
                toast.error(`Please enter valid ${ottSetting?.authenticationType == MESSAGE_TYPE.EMAIL ? 'email' : 'mobile number'}`);
                return;
            }

            let subscriber = await getSubscriber(mobileNumber);
            if (subscriber.success) {
                userRef.current = subscriber.data;
                setUsers(subscriber.data);
                setIsLoading(true);
                let otpRes = await sendOTP(subscriber.data);
                setIsLoading(false);
                if (otpRes.success) {
                    setSentOTPResMessage(otpRes.message);
                    otpRef.current = otpRes.data.otp.toString();
                    setMobileNumber('');
                    setShowVerifyOTP(true);
                } else {
                    toast.error(otpRes.message);
                    return;
                }
            } else {
                toast.error(subscriber.message);
                return
            }

        } else {
            if (otp.join('').length === 4) {
                if (otp.join('') == otpRef.current) {
                    // otp verified
                    setIsLoading(true);
                    let addDeviceRes = await addDevice(userRef.current._id, (userRef.current.Name + '`s Device'));
                    setIsLoading(false);


                    if (!addDeviceRes.success) {
                        setShowDeleteDevicePopup(true);
                        return;
                    }
                    await saveSubscriberLoginHistory(userRef.current._id, PLATFORM[DISPLAYPLATFORM.WEB].Description);
                    utility.setValue(LOCAL_STORAGE_KEY.user, userRef.current);
                    dispatch(setUser(userRef.current));
                    dispatch(setProfiles(userRef.current?.Profiles ?? []));
                    // Analytics event
                    let ottSettings = await getOttSettings();
                    utility.setValue(LOCAL_STORAGE_KEY.analyticType, ottSettings?.data?.analyticsProvider?.SID);
                    AnalyticsManager().logEvent(ANALYTICS_EVENTS.LOGIN, userRef.current);
                    navigate('/');
                } else {
                    toast.error('Please enter valid OTP');
                }
            } else {
                toast.error('Please enter all 4 digits');
            }
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#140d24',
                flexDirection: 'column',
                paddingTop: '100px',
            }}
        >
            <img
                onClick={() => navigate('/')}
                src={ottSetting?.logo ?? 'path/to/default-logo.png'}
                alt="logo"
                style={{ height: '100px', marginBottom: '30px', cursor: 'pointer' }}
                className="max-w-full"
            />
            <div className="bg-white p-4 rounded-lg w-full max-w-md shadow-lg">
                <h2 className="text-2xl font-bold text-center mb-2">Login</h2>
                <p className="text-center text-gray-600 mb-6">
                    Login to continue enjoying uninterrupted <br /> video and personalised experience.
                </p>
                <div >
                    {showVerifyOTP ?
                        <OTPScreen mobileNumber={mobileNumber} otp={otp} setOtp={setOtp} onLogin={onLogin} sentOTPResMessage={sentOTPResMessage} />
                        :
                        <input
                            style={{ width: '100%' }}
                            type="text"
                            placeholder={ottSetting?.authenticationType == MESSAGE_TYPE.EMAIL ? 'Email' : 'Mobile Number'}
                            value={mobileNumber}
                            onChange={handleInputChange}
                            onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    onLogin();
                                }
                            }}
                            aria-describedby="input-error"
                            className="border border-red-400 rounded-lg px-4 py-2 mb-1"
                        />
                    }
                </div>
                <p id="input-error" className="text-red-500 text-sm mb-4">
                    {/* {error} */}
                </p>
                <button
                    style={{
                        width: '100%',
                        padding: '10px',
                        backgroundColor: '#ff4081',
                        color: '#fff',
                        borderRadius: '5px',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '16px',
                    }}
                    onClick={onLogin}
                >
                    {isLoading ? <i className='fa fa-spinner fa-spin' /> : showVerifyOTP ? 'Verify OTP' : 'Login'}
                </button>
                {/* not now */}
                <div className="text-center mt-2">
                    Don't have an account? <Link to="/signupWeb" className="text-blue-500 hover:underline">
                        Signup
                    </Link>
                </div>
                <div className="text-center mt-1">
                    <Link to="/" className="text-blue-500 hover:underline">
                        Not now
                    </Link>
                </div>
            </div>
            {<DeleteDeviceConfirmationBox openDeleteDeviceDialogue={showDeleteDevicePopup} onExitDialogue={() => {
                setShowDeleteDevicePopup(false);
            }} user={users} />}
        </div>
    );
}

export default LoginWeb;
